import { Formik, FormikHelpers } from "formik";
import { useEffect, useState } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import ReactQuill from "react-quill";
import * as Yup from "yup";
import GlobalSettingsApi from "../../../api/GlobalSettingsApi";
import { QuillModules } from "../../../config/app-constants";
import { EToastvariant, IGlobalSettingsRoot, ITermsServiceForm } from "../../../config/interfaces";
import { useAppDispatch } from "../../../redux/Store";
import { showToastMsg } from "../../../redux/slice/ToastMsgSlice";
import { UtilService } from "../../../services";
import { ButtonSpinner } from "../../placeholders";

// Validation Schema of Terms and Conditions
const tncSchema = Yup.object().shape({
  terms_of_service: Yup.string().trim().required("This field is required")
});

const TermsOFService = () => {
  const dispatch = useAppDispatch();
  const [termsServiceData, setTermsServiceData] = useState<IGlobalSettingsRoot>();

  useEffect(() => {
    getTermsService();
  }, []);

  // Get TermsService Value
  const getTermsService = async () => {
    try {
      const api = GlobalSettingsApi.getInstance();
      const response = await api.getGlobalSettingByKey("TERMS_AND_CONDITIONS");
      setTermsServiceData(response?.data);
    } catch (error) {
      dispatch(
        showToastMsg({
          isVisible: true,
          title: "Error",
          message: UtilService.getErrorMessage(error),
          variant: EToastvariant.Danger
        })
      );
    }
  };

  const initialTermsServiceFormValues: ITermsServiceForm = {
    terms_of_service: termsServiceData?.value || ""
  };

  // handleSubmit of Terms and Conditions
  const handleTnCFormSubmit = async (
    values: { terms_of_service: string },
    { setSubmitting }: FormikHelpers<any>
  ): Promise<void> => {
    try {
      const api = GlobalSettingsApi.getInstance();
      const _value: any = {
        value: values.terms_of_service
      };
      let _msg = `Terms of service added successfully.`;
      if (termsServiceData?.uuid) {
        await api.updateGlobalSettings(termsServiceData.uuid, _value);
        _msg = `Terms of service updated successfully.`;
      } else {
        _value.key = "TERMS_AND_CONDITIONS";
        await api.createGlobalSettings(_value);
      }

      dispatch(
        showToastMsg({
          isVisible: true,
          title: "Success",
          message: _msg,
          variant: EToastvariant.Success
        })
      );
      // dispatch(fetchGlobalSettings());
    } catch (error) {
      dispatch(
        showToastMsg({
          isVisible: true,
          title: "Error",
          message: UtilService.getErrorMessage(error),
          variant: EToastvariant.Danger
        })
      );
    } finally {
      setSubmitting(false);
    }
  };
  return (
    <>
      <Formik
        enableReinitialize={true}
        initialValues={initialTermsServiceFormValues}
        validationSchema={tncSchema}
        onSubmit={handleTnCFormSubmit}
      >
        {({ handleSubmit, isSubmitting, handleChange, values }) => (
          <>
            <Card className="form-card tab-card">
              <Card.Body>
                <Row>
                  <Col>
                    <Form.Group className="form-group" controlId="terms_of_service">
                      <ReactQuill
                        theme="snow"
                        modules={QuillModules}
                        value={values.terms_of_service}
                        onChange={handleChange("terms_of_service")}
                        placeholder="Enter terms of use"
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <div className="form-btns-wrap">
                  <Button
                    variant="primary"
                    type="button"
                    size="lg"
                    className="btn-w-160 text-white"
                    onClick={() => handleSubmit()}
                  >
                    {!isSubmitting ? "Save" : <ButtonSpinner />}
                  </Button>
                </div>
              </Card.Body>
            </Card>
          </>
        )}
      </Formik>
    </>
  );
};

export default TermsOFService;
